import * as React from 'react';
import { useSelector } from 'react-redux';

import { isFromBuilderSelector, isNewbuildingSelector, selectIsEnabledCallTracking } from '../../selectors';
import { CalltrackingBadge } from '../../components/CalltrackingBadge';
import { isCalltrackingBadgeHiddenGroup } from '../../selectors/experiments';

export const CalltrackingBadgeContainer: React.FC = () => {
  const isEnabledCallTracking = useSelector(selectIsEnabledCallTracking);
  const isBadgeHidden = useSelector(isCalltrackingBadgeHiddenGroup);
  const isNewBuilding = useSelector(isNewbuildingSelector);
  const isFromBuilder = useSelector(isFromBuilderSelector);

  if (!isEnabledCallTracking || (isNewBuilding && isFromBuilder && isBadgeHidden)) {
    return null;
  }

  return <CalltrackingBadge />;
};
